import { render, staticRenderFns } from "./sProducerContractDetailAddenda.vue?vue&type=template&id=e6cb9bf8&scoped=true"
import script from "./sProducerContractDetailAddenda.vue?vue&type=script&lang=js"
export * from "./sProducerContractDetailAddenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cb9bf8",
  null
  
)

export default component.exports